import React from 'react';
import { RouteComponentProps } from 'react-router';

import { useQuery } from '@apollo/client';

import {
  LwcDetails_odProtosListingsServicesListwithcertaintyproduct_getLwcDetails_lwcDetails as DashboardLwcDetails,
  LwcDetails,
  LwcDetailsVariables,
} from '../../graphql/athena/queries/__generated__/LwcDetails';
import { LWC_DETAILS_QUERY } from '../../graphql/athena/queries/LwcDetails';
import { useAthenaSessionQuery } from '../../graphql/athena/queries/Session';
import { compareLwcDetails } from '../../helpers/getAllLeadData';
import { PrivateRouteComponent } from '../PrivateRoute';
import { LeadCardWrapper } from './LeadCardWrapper';
import { SampleLayout } from './SampleLayout';

const LWC_DASHBOARD_NAME = 'lwc  dashboard';

type LwcDashboardProps = RouteComponentProps<{ token?: string }>;

const sortLwcDetailsByState = (lwcDetails: DashboardLwcDetails[]): DashboardLwcDetails[] => {
  // Get an error locally sorting in place
  return [...lwcDetails].sort(compareLwcDetails);
};

export const LwcDashboard: React.FC<LwcDashboardProps> & PrivateRouteComponent = (props) => {
  const { match } = props;
  const detailsToken = match?.params?.token;
  const { customerUuid, data, loading, error } = useAthenaSessionQuery();

  const {
    loading: lwcDetailsLoading,
    error: lwcDetailsError,
    data: lwcDetailsData,
  } = useQuery<LwcDetails, LwcDetailsVariables>(LWC_DETAILS_QUERY, {
    context: {
      clientName: 'athena',
    },
    skip: !customerUuid,
    variables: {
      agentCustomerUuid: customerUuid ?? '',
    },
    errorPolicy: 'all',
  });

  if (loading || error || !data) {
    return null;
  }

  if (lwcDetailsLoading || !lwcDetailsData) return <p>Loading...</p>;

  if (lwcDetailsError) return <p>Error :(</p>;

  const lwcDetailsFromServer =
    lwcDetailsData?.odProtosListingsServicesListwithcertaintyproduct.getLwcDetails?.lwcDetails ??
    [];

  if (lwcDetailsFromServer.length == 0) return <p>No leads to show!</p>;
  const sorted = sortLwcDetailsByState(lwcDetailsFromServer);

  const leadCards = sorted.map((lwcDetails) => {
    return (
      <LeadCardWrapper
        key={lwcDetails.lwcProduct?.sellerLeadToken}
        lwcDetails={lwcDetails}
        agentCustomerUuid={customerUuid ?? ''}
        tokenToShowDetailsFor={detailsToken}
      />
    );
  });
  return <SampleLayout>{leadCards}</SampleLayout>;
};

LwcDashboard.dashboardName = LWC_DASHBOARD_NAME;
LwcDashboard.isAuthorized = () => true;

export default LwcDashboard;
